import React, { useEffect, useState } from 'react';
import { Colors } from "@Styles/Colors.style";
import IconStar from '@/components/icons/searchRes/IconStar';

interface VehicleSnippetHeaderProps {
    vehicleGroupName: string;
    imageUrl: string;
}

const VehicleSnippetHeader: React.FC<VehicleSnippetHeaderProps> = ({ vehicleGroupName, imageUrl }) => {
    const [rating, setRating] = useState(0);
    const [reviews, setReviews] = useState(0);

    useEffect(() => {
        setRating(Number((Math.random() * (4.9 - 3.6) + 3.6).toFixed(1)));
        setReviews(Math.floor(Math.random() * (2000 - 300 + 1) + 300));
    }, []);
    
    return (
        <>
            <h3>
                {vehicleGroupName}
            </h3>
            <div className="gb--vehicle-card__rating">
                <IconStar
                    width={18}
                    height={18}
                    fill={Colors.warningColor}
                />
                <b>{rating}</b>
                <span>
                    ({reviews} reviews)
                </span>
            </div>
            <img
                className="gb--card__image"
                src={imageUrl}
                alt={vehicleGroupName}
            />
        </>
    );
};

export default VehicleSnippetHeader;
